// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { UNCAUGHT_ERROR } from 'errors'

// When we want to throw a submission error to redux-form, we have to consider
// a few things. Redux-form has a built in way of handling submission errors
// at the form level and the field level, but that's it.

// So if we need to display validation errors between multiple fields,
// in parsing a file or in general bad data for the transaction,
// we need to handle that in our own way.

// To manage the above, this function creates a submission errors object
// which uses redux-form's default form level property (_error)
// and also can also include non-field level related messages.

// _apiErrors means nothing to redux form. For the submitErrors object,
// redux-form only cares about _error and any properties which match
// field and field array names in the form which triggered the submit in the first place.

const formatErrorData = err => {
  // This is redux-form's default submission error. It is only accessible
  // from within the form which triggered the submit.
  // As a result, we can't access it through a submit failed modal,
  // (eg. Path Details Submit)
  // or an error component which is rendered outside of the scope of the form itself.
  // (eg. Path Import CSV)
  // But it's good enough 90% of the time.
  const _error = err?.message || UNCAUGHT_ERROR

  const _apiErrors = {
    message: _error,
    errors: err?.json?.errors || null,
  }

  // NOTE - we do not map errors to individual fields here.
  // There is no support for this type of mapping in the backend's validation

  return {
    _apiErrors,
    _error,
  }
}

export default formatErrorData
